<template>
  <v-container>
    <v-card class="text-center px-5 pb-5">
      <v-card-text>
        <v-card-subtitle class="text--secondary text-caption py-0"
          >GBS {{ new Date().getFullYear() }}</v-card-subtitle
        >
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8"
        >
          Übungen
        </div>
      </v-card-text>
      <v-row justify="center" class="mb-2">
        <v-expansion-panels multiple focusable accordion flat tile>
          <v-expansion-panel v-for="chapter in chapters" :key="chapter.id">
            <v-expansion-panel-header class="text-body-2">
              <v-icon class="mr-8">mdi-book</v-icon>
              {{ chapter.title }}
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list-item
                v-for="exercise in showExercise(chapter.id)"
                :key="exercise.id"
                class="text-left"
                @click="openExercise(exercise.id)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-file-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ exercise.title }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item v-show="!showExercise(chapter.id).length">
                <v-list-item-content>
                  <v-list-item-title class="text-caption text--disabled">
                    Keine Übungen in diesem Kapitel.
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-for="exercise in leftoverExercises()"
            :key="exercise.id"
          >
            <v-list-item
              class="text-left other-exercise-list"
              @click="openExercise(exercise.id)"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-edit</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">
                  {{ exercise.title }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-tray-arrow-down</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-card-actions v-show="isStaff || isTutor" class="pa-0">
        <v-row>
          <v-col>
            <v-dialog transition="dialog-bottom-transition" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  depressed
                  color="tertiary"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left> mdi-plus-thick </v-icon>
                  Kapitel Hinzufügen</v-btn
                >
              </template>
              <template v-slot:default="dialog">
                <v-card>
                  <v-card-text class="pt-3 pb-0">
                    <div
                      class="text-h5 font-weight-medium text--primary"
                      style="opacity: 0.8"
                    >
                      Kapitel hinzufügen
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text class="pt-0 pb-1">
                    <v-alert
                      v-if="newChapterMessage.value"
                      :type="newChapterMessage.type"
                      :color="newChapterMessage.color"
                      dense
                      class="text-caption white--text"
                    >
                      {{ newChapterMessage.value }}
                    </v-alert>
                    <v-form>
                      <v-text-field
                        class="mb-2"
                        outlined
                        label="Titel"
                        append-icon="mdi-format-title"
                        :rules="titleRules"
                        :value="newTitle"
                        required
                        v-model="newTitle"
                      />
                      <v-text-field
                        outlined
                        label="Slug"
                        append-icon="mdi-identifier"
                        :rules="slugRules"
                        :value="newSlug"
                        required
                        v-model="newSlug"
                      />
                    </v-form>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-end pt-0 pb-3">
                    <v-btn text @click="dialog.value = false">Schließen</v-btn>
                    <v-btn
                      @click="addNewChapter()"
                      color="primary white--text"
                      text
                      >Hinzufügen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
          <v-col v-show="isStaff">
            <v-btn
              block
              depressed
              color="tertiary"
              class="white--text"
              @click="toNewExerciseView()"
            >
              <v-icon left> mdi-plus-thick </v-icon>
              Übung Hinzufügen</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<!-- TODO: give feedback, when Login credentials are wrong -->

<script>
import { useUserServiceInject } from "@/context";

export default {
  name: "Exercises",
  setup() {
    const { isTutor, isStaff } = useUserServiceInject();
    return { isTutor, isStaff };
  },
  data() {
    return {
      chapters: null,
      exercises: null,
      newTitle: null,
      newSlug: null,
      titleRules: [(t) => !!t || "Darf nicht leer sein."],
      slugRules: [
        (s) => !!s || "Darf nicht leer sein.",
        (s) => this.isUniqueSlug(s) || "Dieser Slug existiert bereits.",
      ],
      newChapterMessage: {
        type: "error",
        color: "alert",
        value: null,
      },
    };
  },
  methods: {
    openExercise(id) {
      this.$router.push({ name: "exercise", params: { id } });
    },
    showExercise(chapter) {
      if (!this.exercises) return [];
      return this.exercises.filter((e) => e.chapter == chapter);
    },
    leftoverExercises() {
      if (!this.exercises) return [];
      if (!this.chapter) return [];
      const chapters = this.chapters.map((c) => c.id);
      return this.exercises.filter((e) => !chapters.includes(e.chapter));
    },
    addNewChapter() {
      if (!this.isUniqueSlug(this.newSlug)) {
        this.newChapterMessage.value =
          "Dieser Slug exisistiert bereits. Bitte wählen Sie einen anderen.";
        this.newChapterMessage.type = "error";
        this.newChapterMessage.color = "alert";
        return;
      }
      if (!this.newTitle || !this.newSlug) {
        console.log(!this.newChapter, !this.newSlug);
        this.newChapterMessage.value =
          "Kein Feld darf leer sein. Bitte füllen Sie alles aus.";
        this.newChapterMessage.type = "error";
        this.newChapterMessage.color = "alert";
        return;
      }
      const newChapter = {
        title: this.newTitle,
        slug: this.newSlug,
      };
      this.$axios
        .post("chapters", newChapter)
        .then(() => {
          this.chapters.push(newChapter);
          this.newChapterMessage.value =
            "Das Kapitel wurde erfolgreich hinzugefügt.";
          this.newChapterMessage.type = "success";
          this.newChapterMessage.color = "success";
        })
        .catch(() => {
          this.newChapterMessage.value =
            "Es ist ein Fehler aufgetreten. Das Kapitel konnte nicht hinzugefügt werden.";
          this.newChapterMessage.type = "error";
          this.newChapterMessage.color = "alert";
        });
    },
    isUniqueSlug(s) {
      const slugs = this.chapters.map((c) => c.slug);
      return !slugs.includes(s);
    },
    toNewExerciseView() {
      this.$router.push({ name: "new.exercise" });
    },
  },
  created() {
    this.$axios
      .get("chapters")
      .then((response) => (this.chapters = response.data));
    this.$axios
      .get("exercises")
      .then((response) => (this.exercises = response.data));
  },
};
</script>

<style>
button {
  background-color: transparent !important;
}
</style>

<style scoped>
.theme--light.v-expansion-panels .v-expansion-panel {
  border-bottom: thin solid rgb(230, 230, 230);
}

.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex: none !important;
}

.v-list-item {
  padding: 0px 24px;
}

.other-exercise-list {
  padding: 0px 24px;
}
</style>
